export default __webpack_public_path__ + "static/Tempoist1.inline-3fd9098e400fcf77b8ff6a561b038a35.png";